<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('attendances')" :icon="'grid'" />
            </div>
            <div 
                class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('store_attendances')"
            >
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <attendance-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="attendance-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { employeeFilter, status } from '../../../Mixins/FilterMixin';
import AppFunction from '../../../../core/helpers/app/AppFunction';

export default {
    extends: CoreLibrary,
    mixins: [status, employeeFilter],
    name: "AppAttendances",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'attendances-table',
            rowData: {},
            options: {
                name: 'AppAttendances',
                url: actions.ATTENDANCE,
                showHeader: true,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('#'),
                        type: 'text',
                        key: 'id',
                    },
                    {
                        title: this.$t('Photo'),
                        type: 'media-object',
                        key: 'employee',
                        mediaTitleKey: '',
                        mediaSubtitleKey: '',
                        default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                        modifier: (value, row) => {
                            return value.photo; // imag url
                        },
                        isVisible: true
                    },
                    {
                        title: this.$t('employee'),
                        type: 'custom-html',
                        key: 'employee',
                        modifier: (value, row) => {
                            return `<span>${value.last_name} ${value.middle_name} ${value.first_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('location'),
                        type: 'custom-html',
                        key: 'location',
                        modifier: (value, row) => {
                            return `<span>${value.name}</span>`;
                        }
                    },
                    {
                        title: this.$t('event_time'),
                        type: 'text',
                        key: 'event_time',
                    },
                    {
                        title: this.$t('event_type'),
                        type: 'custom-html',
                        key: 'event_type',
                        modifier: (value, row) => {
                            if(value == 'in') {
                                return `<span class="badge rounded-pill badge-success">${this.$t(value)}</span>`;
                            } else {
                                return `<span class="badge rounded-pill badge-warning">${this.$t(value)}</span>`
                            }
                        }
                    },

                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    // {
                    //     title: this.$t('comment'),
                    //     icon: 'file-text',
                    //     type: 'none',
                    //     component: 'attendance-add-modal',
                    //     modalId: 'attendance-add-edit-modal',
                    //     modifier: () => this.$can('update_attendances'),
                    // },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'attendance-delete',
                        modifier: () => this.$can('delete_attendances'),
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                    {
                        title: this.$t("employee"),
                        type: "multi-select-filter",
                        key: "employees",
                        option: [],
                        permission: true
                    },
                ],
                showFilter: true,
                showSearch: false,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#attendance-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.ATTENDANCE}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.ATTENDANCE}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#attendance-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
